import { Controller } from "stimulus"

export default class extends Controller {
  highlightAgencyOnMap (event) {
    const agencyId = event.currentTarget.dataset.agenciesMapLayoutAgencyIdParam
    this.element.dispatchEvent(new CustomEvent("highlight-agency-on-map", {
      bubbles: true,
      cancelable: true,
      detail: {
        agencyId: agencyId
      }
    }))
  }
}
